import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class PartSizeService {
    constructor(http) {
        this.http = http;
        this.singular = 'part size';
        this.plural = 'part sizes';
        this.editor = PLATFORM.moduleName('pages/standard-setup/part-sizes/editor/index');
    }

    async filter(loadOptions) {
        const response = await this.http.fetch(`part-sizes/filter/${loadOptions}`);
        return await response.json();
    }

    async create(partSize) {
        await this.http.fetch('part-sizes', { method: 'POST', body: json(partSize) });
    }

    async update(partSize) {
        await this.http.fetch(`part-sizes/${partSize.id}`, { method: 'PUT', body: json(partSize) });
    }

    async delete(id) {
        await this.http.fetch(`part-sizes/${id}`, { method: 'DELETE' });
    }

    async getById(id) {
        const response = await this.http.fetch(`part-sizes/${id}`);
        return await response.json();
    }

    async filterTopThree(query) {
        if (query == null || query.length === 0) return [];
        const response = await this.http.fetch(`part-sizes/top-three/${query}`);
        return await response.json();
    }
}